import React from 'react';
import './app.css';
import Routes from './routes'
import '@progress/kendo-theme-material/dist/all.css';

export default function App() {
    return (
        <Routes />
    );
}